export const ProductRateStructure = (): JSX.Element => <h1>Rate Structure</h1>;
